export default __webpack_public_path__ + "static/media/tick.06c5ca64.svg";